<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-law`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M30 41a1 1 0 011 1v2a1 1 0 01-1 1H8a1 1 0 01-1-1v-2a1 1 0 011-1h22zM28.485 2.414l8.486 8.486a2 2 0 010 2.828l-4.087 4.085 12.024 12.024c.988.988 1.29 2.582.3 3.717l-.126.134-3.394 3.394c-1.097 1.096-2.695.873-3.73-.059l-.121-.115L25.8 24.872a1.002 1.002 0 01-.123.149l-5.657 5.657a1 1 0 01-1.414 0l-9.9-9.9a1 1 0 010-1.414l5.657-5.657a1 1 0 011.414 0l.527.527a20.168 20.168 0 002.898-2.398A21.178 21.178 0 0021.3 9.363l.114.122a2 2 0 010-2.828l4.243-4.243a2 2 0 012.828 0zm-.13 16.528a19.846 19.846 0 00-1.439 1.388L39.85 33.264l1.415-1.415-12.909-12.907zm-13.284-.285l-1.414 1.414 5.657 5.657 1.414-1.414-5.657-5.657zm9.083-6.432a24.521 24.521 0 01-2.123 2.44 24.09 24.09 0 01-2.855 2.439l2.865 2.867a24 24 0 014.856-5.003l-2.743-2.743zm2.917-5.568L25.657 8.07l5.657 5.657 1.414-1.414-5.657-5.657z"/></svg>
</template>
<script>

export default {
  name: 'IconLaw',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
